import { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

import getPath from "@/modules/get-path";
import { hasProjectSucceeded } from "@/utils";

export default function useProcessedState({ navigateToRoot = true } = {}) {
  const { project } = useOutletContext();

  const navigate = useNavigate();

  useEffect(() => {
    if (!hasProjectSucceeded(project) && navigateToRoot) {
      navigate(getPath(project));
    }
  }, [project]);

  return {
    skipRender: !hasProjectSucceeded(project),
  };
}
